import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Group summary='Client session lifecycle callbacks' mdxType="Group">
    <Item title='onBeforeClientSessionUpdate' subtitle='() => void' mdxType="Item">
        Called when the client session is in the process of being updated. Use it to show a loading indicator on your
        UI.
    </Item>
    <Item title='onClientSessionUpdate' subtitle='(clientSession: ClientSession) => void' mdxType="Item">
        Called when the client session has been updated by the checkout. Returns the updated client session which can be
        used to inform your UI. For example updating tax, shipping or discount amounts displayed to your customers.
    </Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      